import axios from "axios";
import DOMPurify from "dompurify";

export function initializeRiskReportsModal() {
  const modal = document.getElementById("riskReportsModal");
  const trigger = document.getElementById("openRiskReports");
  const jq = window.jQuery;
  if (!modal || !trigger || !jq || typeof jq.fn.modal !== "function") {
    return;
  }

  const body = modal.querySelector(".modal-body");
  const back = modal.querySelector("[data-reports-back]");
  let listUrl = trigger.href;
  let request = null;

  function cancelRequest() {
    if (request) {
      request.abort();
      request = null;
    }
  }

  async function navigate(url, isReport = false) {
    cancelRequest();
    const pending = new AbortController();
    request = pending;
    if (!isReport) {
      listUrl = url;
    }
    back.hidden = !isReport;
    body.setAttribute("aria-busy", "true");
    body.textContent = "Loading…";
    body.scrollTop = 0;
    try {
      const response = await axios.get(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
        signal: pending.signal,
        timeout: 30000,
      });
      if (request !== pending) {
        return;
      }
      const page = new DOMParser().parseFromString(response.data, "text/html");
      const content = page.querySelector(isReport ? ".risk-report" : ".risk-reports");
      if (!content) {
        throw new Error("Unexpected report response");
      }
      body.innerHTML = DOMPurify.sanitize(content.outerHTML);
    } catch (error) {
      if (request !== pending) {
        return;
      }
      body.innerHTML = '<div class="alert alert-danger" role="alert"></div><button type="button" class="btn btn-outline-primary">Try again</button>';
      const status = error.response && error.response.status;
      body.querySelector(".alert").textContent = status === 404
        ? "This report is no longer available."
        : "Reports could not be loaded. Please try again.";
      body.querySelector("button").addEventListener("click", () => navigate(url, isReport));
    } finally {
      if (request === pending) {
        request = null;
        body.setAttribute("aria-busy", "false");
      }
    }
  }

  jq(modal).on("show.bs.modal", () => navigate(trigger.href));
  jq(modal).on("hide.bs.modal", () => {
    cancelRequest();
    body.textContent = "";
    body.setAttribute("aria-busy", "false");
  });
  back.addEventListener("click", () => navigate(listUrl));
  body.addEventListener("click", (event) => {
    const link = event.target.closest("a[data-risk-report-link], .pagination a");
    if (!link || !body.contains(link)) {
      return;
    }
    event.preventDefault();
    navigate(link.href, link.hasAttribute("data-risk-report-link"));
  });
}
